export function parseAiImageTaskParams(params) {
  if (!params) return {}
  if (typeof params === 'string') {
    try {
      const parsed = JSON.parse(params)
      return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
    } catch {
      return {}
    }
  }
  return typeof params === 'object' && !Array.isArray(params) ? params : {}
}

function pushUrl(out, value) {
  const text = String(value || '').trim()
  if (text && /^https?:\/\//i.test(text) && !out.includes(text)) out.push(text)
}

export function extractAiImageResultUrls(data) {
  const out = []
  if (!data || typeof data !== 'object') return out

  const result = data.result
  if (Array.isArray(result)) {
    result.forEach((item) => pushUrl(out, item))
  } else {
    pushUrl(out, result)
  }

  const params = parseAiImageTaskParams(data.params)
  const candidates = [
    data.result_image_oss_path,
    data.image_url,
    data.image,
    data.url,
    params.result_image_oss_path,
    params.output_image,
  ]
  candidates.forEach((item) => pushUrl(out, item))

  const arrayCandidates = [
    data.image_urls,
    data.images,
    data.urls,
    params.result,
    params.image_urls,
  ]
  for (const list of arrayCandidates) {
    if (Array.isArray(list)) list.forEach((item) => pushUrl(out, item))
  }

  return out
}

export function extractAiImageReferenceUrls(params) {
  const parsed = parseAiImageTaskParams(params)
  const out = []
  const value = parsed.image_url ?? parsed.image_urls
  if (Array.isArray(value)) value.forEach((item) => pushUrl(out, item))
  else pushUrl(out, value)
  return out
}

export function aiImageDownloadFileName(taskId = '', index = 0, url = '') {
  const cleanTaskId = String(taskId || 'ai-image').replace(/[^\w-]+/g, '').slice(0, 48) || 'ai-image'
  const cleanIndex = Math.max(1, Number(index) + 1)
  const pathname = String(url || '').split('?')[0].split('#')[0]
  const ext = pathname.includes('.') ? pathname.split('.').pop() : 'png'
  const safeExt = /^[a-z0-9]{2,5}$/i.test(ext) ? ext.toLowerCase() : 'png'
  return `${cleanTaskId}-${cleanIndex}.${safeExt}`
}
